import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class FetchTermsOfServiceFileUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(locale: string) {
    return this.repo.fetchTermsOfServiceFile(locale);
  }
}
